import { categories } from "@/mocks/categories";

type FilterBarProps = {
  search: string;
  onSearch: (value: string) => void;
  activeCat: string;
  onCatChange: (value: string) => void;
  activeEra: string;
  onEraChange: (value: string) => void;
  resultCount: number;
};

const eras = [
  { id: "all", label: "全部年代" },
  { id: "1990s", label: "1990s" },
  { id: "2000s", label: "2000s" },
  { id: "2010s", label: "2010s" },
  { id: "2020s", label: "2020s" },
];

const catTabs = [{ id: "all", name: "全部主题", icon: "ri-apps-2-line" }, ...categories];

const FilterBar = ({
  search,
  onSearch,
  activeCat,
  onCatChange,
  activeEra,
  onEraChange,
  resultCount,
}: FilterBarProps) => (
  <div className="rounded-lg border border-foreground-950/10 bg-background-50 p-4 md:p-5">
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div className="relative w-full md:max-w-sm">
        <i className="ri-search-line pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-base text-foreground-400"></i>
        <input
          type="search"
          value={search}
          onChange={(event) => onSearch(event.target.value)}
          placeholder="搜索旧料标题、关键词…"
          aria-label="搜索旧料"
          className="w-full rounded-md border border-foreground-950/15 bg-background-100 py-2.5 pl-10 pr-3.5 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
        />
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <span className="font-label text-xs text-foreground-500">年代</span>
        {eras.map((era) => (
          <button
            key={era.id}
            type="button"
            onClick={() => onEraChange(era.id)}
            className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 font-label text-xs transition-colors ${
              activeEra === era.id
                ? "bg-foreground-950 text-background-50"
                : "bg-background-200 text-foreground-700 hover:bg-background-300"
            }`}
          >
            {era.label}
          </button>
        ))}
      </div>
    </div>

    <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-foreground-950/10 pt-4">
      {catTabs.map((cat) => (
        <button
          key={cat.id}
          type="button"
          onClick={() => onCatChange(cat.id)}
          className={`inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md px-3.5 py-2 font-label text-sm transition-colors ${
            activeCat === cat.id
              ? "bg-primary-500 text-background-50"
              : "bg-background-100 text-foreground-700 hover:bg-background-200"
          }`}
        >
          <i className={`${cat.icon} text-base`}></i>
          {cat.name}
        </button>
      ))}
      <span className="ml-auto font-label text-xs text-foreground-500">
        共 <span className="font-bold text-primary-600">{resultCount}</span> 条结果
      </span>
    </div>
  </div>
);

export default FilterBar;